module.exports = __webpack_public_path__ + "img/nhtj.d93d10d2.svg";